export enum ChambersIndexColorEnum {
    GREEN = 'Green',
    YELLOW = 'Yellow',
    ORANGE = 'Orange',
    RED = 'Red',
}
